import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatApiErrorDetail } from "../lib/api";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle="Enter your account email and we'll send a reset link.">
      {sent ? (
        <div className="space-y-4">
          <p data-testid="forgot-confirm" className="text-sm text-ftext leading-relaxed">
            If that email is registered, a reset link has been sent. Check your inbox.
          </p>
          <Link to="/login" className="block font-mono-data text-xs uppercase tracking-wider text-sky hover:underline">
            ← Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="font-mono-data text-xs uppercase tracking-wider text-ftext2">Email</Label>
            <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="rounded-none bg-ink border-line2 focus-visible:ring-[#38BDF8]" />
          </div>
          {error && <p className="text-xs text-[#FCA5A5] font-mono-data">{error}</p>}
          <button data-testid="forgot-submit-btn" type="submit" disabled={loading}
            className="w-full bg-sky hover:bg-skyH text-primary-foreground font-mono-data text-sm font-semibold uppercase tracking-wider px-4 py-3 transition-colors disabled:opacity-60">
            {loading ? "Sending…" : "Send reset link"}
          </button>
          <Link to="/login" className="block font-mono-data text-xs uppercase tracking-wider text-ftext3 hover:text-sky transition-colors">
            ← Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
